import { Link } from "react-router-dom";
import { SITE } from "../constants/site";
import { Mail, MapPin, ShieldCheck } from "lucide-react";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-slate-950 text-slate-300"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src={SITE.logo}
                                alt={`${SITE.appName} logo`}
                                className="h-11 w-11 rounded-xl ring-1 ring-white/10"
                            />
                            <div>
                                <div className="font-display font-semibold text-white text-xl">
                                    {SITE.appName}
                                </div>
                                <div className="text-xs text-slate-400 mt-0.5">
                                    An app by {SITE.company}
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-sm text-slate-400 max-w-sm leading-relaxed">
                            The calm, secure home for everything your family
                            needs to stay organised — calendars, lists,
                            documents, medical records, and a private photo
                            vault.
                        </p>

                        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-slate-200">
                            <ShieldCheck className="h-4 w-4 text-brand-teal" />
                            POPIA Compliant · South Africa
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="font-display text-white font-semibold text-sm uppercase tracking-widest mb-4">
                            Legal
                        </h4>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href="/#features"
                                    data-testid="footer-link-features"
                                    className="hover:text-white transition-colors"
                                >
                                    Features
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/privacy"
                                    data-testid="footer-link-privacy"
                                    className="hover:text-white transition-colors"
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/terms"
                                    data-testid="footer-link-terms"
                                    className="hover:text-white transition-colors"
                                >
                                    Terms of Service
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/account-deletion"
                                    data-testid="footer-link-account-deletion"
                                    className="hover:text-white transition-colors"
                                >
                                    Account &amp; Data Deletion
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="font-display text-white font-semibold text-sm uppercase tracking-widest mb-4">
                            Contact
                        </h4>
                        <ul className="space-y-4 text-sm">
                            <li className="flex items-start gap-3">
                                <MapPin className="h-4 w-4 mt-0.5 text-brand-coral flex-shrink-0" />
                                <span
                                    data-testid="footer-address"
                                    className="text-slate-300 leading-relaxed"
                                >
                                    {SITE.company}
                                    <br />
                                    {SITE.address}
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail className="h-4 w-4 mt-0.5 text-brand-teal flex-shrink-0" />
                                <div>
                                    <div className="text-slate-400 text-xs">
                                        Support
                                    </div>
                                    <a
                                        href={`mailto:${SITE.supportEmail}`}
                                        data-testid="footer-support-email"
                                        className="hover:text-white transition-colors"
                                    >
                                        {SITE.supportEmail}
                                    </a>
                                </div>
                            </li>
                            <li className="flex items-start gap-3">
                                <ShieldCheck className="h-4 w-4 mt-0.5 text-brand-purple flex-shrink-0" />
                                <div>
                                    <div className="text-slate-400 text-xs">
                                        Information Officer
                                    </div>
                                    <a
                                        href={`mailto:${SITE.infoOfficerEmail}`}
                                        data-testid="footer-info-officer-email"
                                        className="hover:text-white transition-colors"
                                    >
                                        {SITE.infoOfficerEmail}
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-500">
                    <span>
                        © {new Date().getFullYear()} {SITE.company}. All rights
                        reserved.
                    </span>
                    <span>
                        Built with care in Durban, South Africa.
                    </span>
                </div>
            </div>
        </footer>
    );
};
